import { Component } from '@angular/core';
import {MessageService} from "primeng/api";

@Component({
  selector: 'app-admin-list',
  templateUrl: './admin-list.component.html',
  styleUrls: ['./admin-list.component.scss'],
  providers: [MessageService]
})
export class AdminListComponent {

}
